/** Maps EU PII model entity types to shorter mask category labels. */

const CATEGORY_MAP = {
  PERSON_NAME: 'name',
  DATE_OF_BIRTH: 'date',
  ORGANIZATION_NAME: 'organization',
  EMAIL_ADDRESS: 'email',
  PHONE_NUMBER: 'phone',
  POSTAL_ADDRESS: 'address',
  LOCATION: 'location',
  GEO_LOCATION: 'location',
  VEHICLE_IDENTIFIER: 'license_plate',
  FINANCIAL_AMOUNT: 'number',
  INCOME_COMPENSATION: 'number',
  BANK_ACCOUNT_IDENTIFIER: 'account',
  PAYMENT_CARD: 'number',
  PAYMENT_CARD_SECURITY: 'number',
  DOCUMENT_REFERENCE: 'id',
  ACCOUNT_IDENTIFIER: 'account',
  PERSON_IDENTIFIER: 'id',
  ORGANIZATION_IDENTIFIER: 'id',
  PERSON_ATTRIBUTE: 'name',
  PERSON_ALIAS: 'name',
  PERSON_ROLE_OR_TITLE: 'role',
  CONTACT_HANDLE: 'account',
  IP_ADDRESS: 'id',
  DEVICE_IDENTIFIER: 'id',
  COOKIE_IDENTIFIER: 'id',
  AUTH_SECRET: 'id',
  TRADE_UNION_MEMBERSHIP: 'organization',
  PII: 'pii',
};

/** Model types disabled by default (not flagged for review). */
const DEFAULT_DISABLED_TYPES = new Set([
  'HEALTH_DATA',
  'GENETIC_DATA',
  'BIOMETRIC_DATA',
  'RELIGION_OR_BELIEF',
  'POLITICAL_OPINION',
  'SEXUAL_ORIENTATION',
  'TRADE_UNION_MEMBERSHIP',
  'ETHNIC_ORIGIN',
  'CRIMINAL_OFFENCE_DATA',
  'DOCUMENT_REFERENCE',
  'FINANCIAL_AMOUNT',
  'INCOME_COMPENSATION',
  'PII',
  'PERSON_ATTRIBUTE',
  'PERSON_ALIAS',
  'PERSON_IDENTIFIER',
  'ORGANIZATION_IDENTIFIER',
  'CONTACT_HANDLE',
  'GEO_LOCATION',
  'DEVICE_IDENTIFIER',
  'COOKIE_IDENTIFIER',
  'AUTH_SECRET',
  'BANK_ACCOUNT_IDENTIFIER',
  'PAYMENT_CARD',
  'PAYMENT_CARD_SECURITY',
]);

/**
 * Types only flagged when at least one of the listed companion types is also present.
 * @type {Record<string, string[]>}
 */
const DEFAULT_COMBINATION_RULES = {
  PERSON_ROLE_OR_TITLE: ['LOCATION', 'ORGANIZATION_NAME', 'GEO_LOCATION', 'POSTAL_ADDRESS'],
};

/** Default minimum model confidence (0–1) required to flag an entity. */
const DEFAULT_MIN_CONFIDENCE = 0;

const ALL_MODEL_TYPES = [
  'PERSON_NAME',
  'DATE_OF_BIRTH',
  'PERSON_ATTRIBUTE',
  'PERSON_ALIAS',
  'PERSON_IDENTIFIER',
  'PERSON_ROLE_OR_TITLE',
  'ORGANIZATION_NAME',
  'ORGANIZATION_IDENTIFIER',
  'EMAIL_ADDRESS',
  'PHONE_NUMBER',
  'CONTACT_HANDLE',
  'POSTAL_ADDRESS',
  'LOCATION',
  'GEO_LOCATION',
  'IP_ADDRESS',
  'DEVICE_IDENTIFIER',
  'COOKIE_IDENTIFIER',
  'ACCOUNT_IDENTIFIER',
  'AUTH_SECRET',
  'BANK_ACCOUNT_IDENTIFIER',
  'PAYMENT_CARD',
  'PAYMENT_CARD_SECURITY',
  'DOCUMENT_REFERENCE',
  'FINANCIAL_AMOUNT',
  'INCOME_COMPENSATION',
  'VEHICLE_IDENTIFIER',
  'HEALTH_DATA',
  'GENETIC_DATA',
  'BIOMETRIC_DATA',
  'RELIGION_OR_BELIEF',
  'POLITICAL_OPINION',
  'SEXUAL_ORIENTATION',
  'TRADE_UNION_MEMBERSHIP',
  'ETHNIC_ORIGIN',
  'CRIMINAL_OFFENCE_DATA',
  'PII',
];

const MASK_CATEGORIES = [...new Set([...Object.values(CATEGORY_MAP), 'zip_code', 'number', 'id', 'account', 'role', 'website'])];
const PII_SCAN_SETTINGS_KEY = 'piiScanSettings';

module.exports = {
  CATEGORY_MAP,
  DEFAULT_DISABLED_TYPES,
  DEFAULT_COMBINATION_RULES,
  DEFAULT_MIN_CONFIDENCE,
  ALL_MODEL_TYPES,
  MASK_CATEGORIES,
  PII_SCAN_SETTINGS_KEY,
};
